import { fetchUser as fetchUserService } from '../../../services/userService'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchUser = createAsyncThunk('user/fetchUser', fetchUserService)

